import React, { Component } from "react";

const PortfolioListContent = [
    {
        image: 'image-1',
        category: 'Imperial War Museum, Duxford',
        title: 'Airborne Assault Exhibition',
        link: "/duxford-case-study"
    },
    {
        image: 'image-2',
        category: 'Bolton Museum & Aquarium',
        title: 'Dinosaur Suspension Project',
        link: "/bolton-case-study"
    },
    {
        image: 'image-3',
        category: 'Wakefield Museum',
        title: 'Working With Wakefield Museum',
        link: "/wakefield-case-study"
    }
]

class PortfolioList extends Component{
    render(){
        const {column , styevariation } = this.props;
        const list = PortfolioListContent.slice(0 , this.props.item);
        return(
            <React.Fragment> 
                {list.map((value , index) => (
                    <div className={`${column}`} key={index}>
                        <div className={`portfolio ${styevariation}`}>
                            <a href={value.link}>
                                <div className="thumbnail-inner">
                                    <div className={`thumbnail ${value.image}`}></div>
                                    <div className={`bg-blr-image ${value.image}`}></div>
                                </div>
                            </a>
                            <div className="content">
                                <div className="inner">
                                    <p>{value.category}</p>
                                    <h4><a href={value.link}>{value.title}</a></h4>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
               
            </React.Fragment>
        )
    }
}
export default PortfolioList;